import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import { bsc } from '@reown/appkit/networks';
import { http } from 'viem';

export const projectId = 'aa931bde5dd770a2854b18a636a8da97';

if (!projectId) {
  throw new Error('Project ID is not defined');
}

const networks = [bsc];
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: true,
  customRpcUrls: {
    'eip155:56': [{ url: 'https://bnb-mainnet.g.alchemy.com/v2/_R-gfMvFzGQV1fCIVr6aj' }] // This will be overridden
  },
  transports: {
    [bsc.id]: http('https://bnb-mainnet.g.alchemy.com/v2/_R-gfMvFzGQV1fCIVr6aj') // This takes precedence
  }
});

export const config = wagmiAdapter.wagmiConfig;
